module.exports = "<router-outlet></router-outlet>\n<app-confirm-dialog></app-confirm-dialog>\n<app-loader></app-loader>\n"